import React from 'react';

function PopupHeadPatDetail({ patName, chartid, agestr, gender, dob }) {
  return (
    <div className="hdr-pt-info" style={{ width: 'unset' }}>
      <span className="black-txt clear-right10">Prior Authorization:</span>
      {patName}
      <span className="red"> | </span>
      ID: {chartid}
      <span className="red"> | </span>
      {agestr}-[{gender && gender.toUpperCase().substr(0, 1)}]
      <span className="red"> | </span>
      DOB:{dob}
    </div>
  );
}

export default PopupHeadPatDetail;
